import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonService } from 'src/app/services/common.service';
import { JwtDecoderService } from 'src/backend/helpers/jwt-decoder.service';
import { UserService } from 'src/backend/services/user-access-services/user.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  leftBannerImgurl = 'assets/images/forgot-password-banner.png';
  IsValidated = false;
  HasWhatsapp = false;
  EmailMode = false;
  GroupId;
  PasswordHash = '';
  WhatsAppMode = false;
  UserEmail: string = '';
  WhatsAppNo: string = '';
  ResetPasswordForm!: FormGroup;
  email!: string;
  PhoneNumber: any;
  UserName: any;
  showOldPassword: any = false;
  decodedToken: any;
  Token: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private formBuilder: FormBuilder,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.ResetPasswordForm = this.formBuilder.group({
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8), 
          Validators.maxLength(30), 
          Validators.pattern(
           /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\W\S]{8,}$/
          ),
        ],
      ],
    });
  this.Token = this.route.snapshot.queryParams.token || '/';
}

  onSubmit(): void {
    if (this.ResetPasswordForm.invalid) {
      return;
    }
      const key = {
        Token: this.Token,
        NewPassword : this.ResetPasswordForm.value.password
      }
      this.userService.resetPasswordByEmail(key).subscribe((res: any) => {
        this.toaster.success('Your password has been reset');
        this.router.navigate(['/login']);
      },
        ({ error }) => {
          this.toaster.error('Error', error.message);
        }
      );
  }

  showHideOldPassword(event: any) {
    this.showOldPassword = !this.showOldPassword;
  }


}
